/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Pazaryeri_BaglantisiInputs */

const tr_faq_a_pazaryeri_baglantisi = /** @type {(inputs: Faq_A_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayarlar bölümündeki Pazaryeri Bağlantıları sayfasına git. Trendyol, Hepsiburada, n11 ve Shopify için ayrı ayrı API anahtarı girişi yapabilirsin. Her pazaryerinin kendi Satıcı Paneli üzerinden API anahtarını alman gerekir.`)
};

const en_faq_a_pazaryeri_baglantisi = /** @type {(inputs: Faq_A_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Marketplace Connections under Settings and enter the API keys for Trendyol, Hepsiburada, n11 or Shopify. You get the API key from each marketplace's Seller Panel.`)
};

const de_faq_a_pazaryeri_baglantisi = /** @type {(inputs: Faq_A_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe unter Einstellungen zu Plattform-Verbindungen und gib die API-Schlüssel für Trendyol, Hepsiburada, n11 oder Shopify ein. Den API-Schlüssel erhältst du im Verkäufer-Panel der jeweiligen Plattform.`)
};

const ru_faq_a_pazaryeri_baglantisi = /** @type {(inputs: Faq_A_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите в Настройки и откройте раздел Подключения. Введите API-ключи для Trendyol, Hepsiburada, n11 или Shopify. API-ключ выдаётся в панели продавца каждой площадки.`)
};

/**
* | output |
* | --- |
* | "Go to Marketplace Connections under Settings and enter the API keys for Trendyol, Hepsiburada, n11 or Shopify. You get the API key from each marketplace's Se..." |
*
* @param {Faq_A_Pazaryeri_BaglantisiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_pazaryeri_baglantisi = /** @type {((inputs?: Faq_A_Pazaryeri_BaglantisiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Pazaryeri_BaglantisiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_pazaryeri_baglantisi(inputs)
	if (locale === "de") return de_faq_a_pazaryeri_baglantisi(inputs)
	if (locale === "ru") return ru_faq_a_pazaryeri_baglantisi(inputs)
	return tr_faq_a_pazaryeri_baglantisi(inputs)
});